module.exports = __webpack_public_path__ + "static/img/A7.f570ee0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/A7.png
// module id = 66
// module chunks = 1